/********************************* Utility Functions *********************/

// print price ($51.27 = 5127)
function price(amount) {
    let total = Math.round((parseFloat(amount) / 100));
    return `$${total}`;
}

// convert string of date to human-readable format
function dateToString(dateString) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [year, month, day] = dateString.split('-');
    const date = new Date(Date.UTC(year, month - 1, day));
    return `${months[date.getUTCMonth()]} ${date.getUTCDate()} ${date.getUTCFullYear()}`;
}

// push date object X days
function pushDate(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate.toISOString().split('T')[0];
}

// logout function
function logout() {
    localStorage.removeItem("recharge_session");
    window.location.href = "/account/logout?return_url=%2Faccount/login";
}

// refresh cad pricing
async function refreshCADPricing(subscriptionID, addressID) {
    let formData = new FormData();
    formData.set("subscriptionID", subscriptionID);
    formData.set("addressID", addressID);
    await fetch("https://api.maltertech.com/plantpaper/portal/refresh-canadian-price.php", {
        method: "POST",
        body: formData
    });
    return true;
}

/*************************** Global Variables ***************************/

// us and canada variant ids
const rollsVariantsUS = [handleToVariantID["16-rolls"], handleToVariantID["32-rolls"], handleToVariantID["96-rolls"]];
const bundlesVariantsUS = [handleToVariantID["16-rolls-4-boxes"], handleToVariantID["32-rolls-8-boxes"]];
const tissueVariantUS = handleToVariantID["12-boxes"];

const rollsVariantsCA = [handleToVariantID["32-rolls-ca"], handleToVariantID["96-rolls-ca"]];
const bundlesVariantsCA = [handleToVariantID["32-rolls-8-boxes-ca"]];
const tissueVariantCA = handleToVariantID["12-boxes-ca"];

const cadences = [6, 9, 12, 18, 24];


/******************** Check for back button *****************/

if (performance.navigation.type === 2) {
    window.location.href = "/pages/subscription-portal"
    throw new Error("Refreshing due to back button");
}

/******************** Recharge Setup / Variables ********************/

// start recharge
recharge.init({
    storefrontAccessToken: 'strfnt_383881b23003928358e7be0dad07b9118f2a096156434597cb023f03011c1938',
});

// recharge auth object
let session;

/****************************** Portal Start ********************/

// setup portal
let customer, subscriptions, addresses, paymentMethods;

async function setupPortal() {
    // determine if we're in via shopify or localstorage
    if (["/pages/subscription-portal", "/pages/subscription-portal/"].includes(window.location.pathname)) {
        session = JSON.parse(localStorage.getItem("recharge_session"));
    } else if (["/account", "/account/"].includes(window.location.pathname)) {
        session = await recharge.auth.loginShopifyAppProxy();
    } else {
        // debugging
        let formData = new FormData();
        formData.set("name", "PlantPaper Error");
        formData.set("email", "zach@maltertech.com");
        formData.set("phone", "N/A");
        formData.set("message", `Customer ID: ${customerID}, Page: ${window.location.href}`);
        await fetch("https://api.maltertech.com/maltertech/contact.php", {method: "POST", body: formData});

        // generic error
        await Swal.fire({
            icon: "warning",
            title: "It doesn't look like you're logged in. Let's try again.",
        });
        logout();
        return;
    }

    // fetch customer, addresses and subscriptions
    try {
        await Promise.all([
            recharge.customer.getCustomer(session),
            recharge.subscription.listSubscriptions(session, {
                limit: 25,
                sort_by: 'id-desc',
            }),
            recharge.address.listAddresses(session),
            recharge.paymentMethod.listPaymentMethods(session),
        ])
            .then(response => {
                customer = response[0]
                subscriptions = response[1].subscriptions;
                addresses = response[2].addresses;
                paymentMethods = response[3].payment_methods;
            });
    } catch (e) {
        // GA4 errors
        gtag('event', 'portal_error_login');

        // debugging
        let formData = new FormData();
        formData.set("error_raw", e);
        formData.set("error_json", JSON.stringify(e));
        formData.set("token", JSON.stringify(session));
        formData.set("customer_id", customerID);
        formData.set("user_agent", navigator.userAgent);
        formData.set("time", new Date().toISOString());
        formData.set("page", window.location.href);
        await fetch("https://api.maltertech.com/plantpaper/log.php", {method: "POST", body: formData});

        // generic error
        await Swal.fire({
            icon: "warning",
            title: "We're having an issue accessing your account.",
            text: "Please refresh and try again otherwise contact info@plantpaper.us with error code P1."
        });

        logout();
        return;
    }

    // GA4 login
    gtag('event', 'portal_login');

    // setup intro
    document.querySelector("#introName").textContent = `Welcome ${customer.first_name ?? ""},`;

    // setup intro close
    document.querySelector("#introAnnouncementClose").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.remove("active");
        document.querySelector("#introOpen").classList.add("active");
    });

    // setup intro open
    document.querySelector("#introOpen").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.add("active");
        document.querySelector("#introOpen").classList.remove("active");
    });

    // are they a legacy subscriber
    let isLegacy = false;
    subscriptions.forEach(subscription => {
        // check if they're active
        if (subscription.status !== "active") return;

        // parse their price
        let currentSubscriptionPrice = parseFloat(subscription.price) * 100;

        // find product in our matrix
        let product = products[subscription.external_variant_id.ecommerce];

        // check if this option is their current product and check if their price is lower than retail
        if (currentSubscriptionPrice < product.subscription_price) {
            isLegacy = true;
        }
    });

    // check if they're a legacy subscriber
    if (isLegacy || localStorage.getItem("isLegacy")) {
        document.querySelector("#introAnnouncement").classList.add("warning");
        document.querySelector("#introAnnouncementBody").innerHTML = `Hi Planter. You currently have a legacy discount on your subscription. If you add tissues to your subscription to make it a bundle, or switch into another pack size, rest assured your discount will be retained, but the discounted price will not immediately be reflected in your portal.`;
    }

    // append list of subscriptions to intro header
    subscriptions.forEach((subscription) => {
        // function to render subscription
        async function renderSubscription(target = null, refreshData = false, updated = []) {
            // check if we need to refresh data
            if (refreshData) {
                // fetch customer, addresses and subscriptions
                subscriptions = (await recharge.subscription.listSubscriptions(session, {
                    limit: 25,
                    sort_by: 'id-desc',
                })).subscriptions;
                addresses = (await recharge.address.listAddresses(session)).addresses;
                paymentMethods = (await recharge.paymentMethod.listPaymentMethods(session)).payment_methods;

                // refresh tissues
                setupEligibleTissueOffers();
            }

            // find the corresponding address for this subscription
            let address = addresses.filter(address => address.id === subscription.address_id)[0];

            // find the payment method id
            let paymentMethod = paymentMethods.filter(payment_method => payment_method.id === address.payment_method_id)[0];

            // check if no payment method
            if (!paymentMethod) {
                return;
            }

            // find product in our matrix
            let product = products[subscription.external_variant_id.ecommerce];

            // parse their price
            let currentSubscriptionPrice = parseFloat(subscription.price) * 100;

            // function to plan HTML
            function planHTML() {
                // function to generate option HTML based on the variant
                function optionHTML(variantID) {
                    // default price
                    let retailPrice = price(products[variantID].subscription_price);

                    // check if this option is the current subscription
                    let isActiveProduct = variantID === product.variant_id;

                    // check if this option is their current product and check if their price is lower than retail
                    if (isActiveProduct && currentSubscriptionPrice < product.subscription_price) {
                        retailPrice = `Legacy - ${price(currentSubscriptionPrice)}`
                    }

                    // return HTML
                    return `
                        <option value="${variantID}" ${isActiveProduct ? "selected" : ""}>
                            ${products[variantID].modify_title} (${retailPrice})
                        </option>
                    `;
                }

                // html string
                let HTML = "";

                // check for USA plan
                if (rollsVariantsUS.includes(product.variant_id) || bundlesVariantsUS.includes(product.variant_id)) {
                    // add base plans and select their current variant
                    rollsVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // check for CA plan
                else if (rollsVariantsCA.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id)) {
                    rollsVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // return their current variant
                else {
                    HTML += `<option value="${product.variant_id}">${product.modify_title} (${price(currentSubscriptionPrice)})</option>`;
                }

                return HTML;
            }

            // function for cadence html
            function cadenceHTML() {
                let HTML = "";

                // generate HTML
                cadences.forEach(cadence => {
                    HTML += `<option value="${cadence}" ${cadence === subscription.order_interval_frequency ? "selected" : ""}>Every ${cadence} weeks</option>`;
                });

                // check if we have a custom cadence
                if (!cadences.includes(subscription.order_interval_frequency)) {
                    HTML += `<option selected>Every ${subscription.order_interval_frequency} ${subscription.order_interval_unit}</option>`;
                }

                return HTML;
            }

            // function for next delivery date html
            function nextDeliveryDateHTML() {
                // active subscription with no next charge date means the payment method faild
                if (subscription.status === "active" && subscription.next_charge_scheduled_at) {
                    return dateToString(subscription.next_charge_scheduled_at);
                } else if (subscription.status === "active") {
                    return "Payment Failed"
                } else {
                    return "N/A";
                }
            }

            // address html
            function addressHTML() {
                let HTML = "";

                // loop through addresses
                addresses.forEach(address => {
                    HTML += `<option value="${address.id}" ${address.id === subscription.address_id ? "selected" : ""}>${address.address1}</option>`;
                });

                return HTML;
            }

            // create the subscription HTML (only show active by default)
            let HTML = `
                <div class="portalSubscriptionsGridItem ${subscription.status === "active" ? "active" : ""}" data-id="${subscription.id}" data-status="${subscription.status}">
                    <div class="portalSubscriptionsGridItemHeader">
                        <img class="portalSubscriptionsGridItemHeaderImage" src="${product.featured_image}">
                        <div class="portalSubscriptionsGridItemHeaderTitle">${product.title}</div>
                        <div class="portalSubscriptionsGridItemHeaderGeneral">
                            <div class="portalSubscriptionsGridItemHeaderGeneralCurrent">Delivered every ${subscription.order_interval_frequency} <span class="portalSubscriptionsGridItemHeaderGeneralCurrentModify">${subscription.order_interval_unit}${subscription.order_interval_frequency > 1 ? "s" : ""}</span></div>
                            <button class="portalSubscriptionsGridItemHeaderGeneralModify">
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                </svg>
                                Modify Subscription
                            </button>
                        </div>
                        <div class="portalSubscriptionsGridItemHeaderUpdated">
                            <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                            </svg>
                            Subscription Updated
                        </div>
                    </div>
                    <div class="portalSubscriptionsGridItemPadding">
                        <div class="portalSubscriptionsGridItemModify">
                            <div class="portalSubscriptionsGridItemModifyTitle">Modify your subscription:</div>
                            <div class="portalSubscriptionsGridItemModifyForm">
                                <select class="portalSubscriptionsGridItemModifyFormVariant">${planHTML()}</select>
                                <select class="portalSubscriptionsGridItemModifyFormCadence">${cadenceHTML()}</select>
                            </div>
                            <div class="portalSubscriptionsGridItemModifyActions">
                                <button class="portalSubscriptionsGridItemModifyActionsSave portalButton primary">Update Subscription</button>
                                <button class="portalSubscriptionsGridItemModifyActionsCancel">No thanks, leave as-is</button>
                            </div>
                            <button class="portalSubscriptionsGridItemModifyExit">
                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 876">
                                        <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                        <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <div class="portalSubscriptionsGridItemResume ${subscription.status === "cancelled" ? "active" : ""}">
                            <div class="portalSubscriptionsGridItemResumeLabel portalButton">Inactive</div>
                            <button class="portalSubscriptionsGridItemResumeNow portalButton">Re-activate</button>
                        </div>
                        <div class="portalSubscriptionsGridItemDelivery ${subscription.status === "active" ? "active" : ""}">
                            <div class="portalSubscriptionsGridItemDeliveryTitle">
                                Next Order Date:
                                <div class="portalSubscriptionsGridItemDeliveryTitleUpdated">
                                    <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                    </svg>
                                    Order Date Updated
                                </div> 
                            </div>
                            <div class="portalSubscriptionsGridItemDeliveryDate">${nextDeliveryDateHTML()}</div>
                            <button class="portalSubscriptionsGridItemDeliveryModify">
                                or choose next order date:
                                <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 853">
                                        <rect id="Rectangle 35" width="30.5108" height="25.622" fill="#414141" fill-opacity="0.23"/>
                                        <line id="Line 87" y1="4.71045" x2="30.5108" y2="4.71045" stroke="white"/>
                                        <line id="Line 91" y1="11.6602" x2="30.5108" y2="11.6602" stroke="white"/>
                                        <line id="Line 92" y1="18.6074" x2="30.5108" y2="18.6074" stroke="white"/>
                                        <path id="Line 88" d="M7.34375 25.6221L7.34375 5.21136" stroke="white"/>
                                        <path id="Line 89" d="M15.6367 25.6221L15.6367 5.21136" stroke="white"/>
                                        <path id="Line 90" d="M23.5391 25.6221L23.5391 5.21136" stroke="white"/>
                                    </g>
                                </svg>
                            </button>
                            <div class="portalSubscriptionsGridItemDeliveryReschedule">
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleNow portalButton primary">Send Now</button>
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleWeek portalButton">Push back 1 week</button>
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleMonth portalButton">Push back 1 month</button>
                            </div>
                        </div>
                        <div class="portalSubscriptionsGridItemAddress">
                            <div class="portalSubscriptionsGridItemAddressCurrent active">                        
                                <div class="portalSubscriptionsGridItemAddressCurrentLabel">
                                    Delivered to:
                                    <div class="portalSubscriptionsGridItemAddressCurrentLabelUpdated">
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                        </svg>
                                        Address Updated
                                    </div>
                                </div>
                                <div class="portalSubscriptionsGridItemAddressCurrentName">
                                    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"/>
                                    </svg>
                                    ${address.address1}
                                </div>
                                <button class="portalSubscriptionsGridItemAddressCurrentModify">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                    </svg>
                                    Change Address
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemAddressEdit">
                                <div class="portalSubscriptionsGridItemAddressEditLabel">Modify address:</div>
                                <select class="portalSubscriptionsGridItemAddressEditSelect">
                                    ${addressHTML()}
                                    <option value="new">Add a new address</option>
                                </select>
                                <form class="portalSubscriptionsGridItemAddressEditForm">
                                    <input type="text" name="first_name" placeholder="First Name" aria-label="First Name" required>
                                    <input type="text" name="last_name" placeholder="Last Name" aria-label="Last Name" required>
                                    <input type="text" name="address1" placeholder="Address Line 1" aria-label="Address Line 1" required>
                                    <input type="text" name="address2" placeholder="Address Line 2" aria-label="Address Line 2">
                                    <input type="text" name="city" placeholder="City" aria-label="City" required>
                                    <input type="text" name="province" placeholder="State" aria-label="State" required>
                                    <input type="number" name="zip" placeholder="ZIP code" aria-label="ZIP code" required>
                                    <select name="country_code" aria-label="Country Code" required">
                                        <option selected disabled>Country</option>
                                        <option value="US">United States</option>
                                        <option value="CA">Canada</option>
                                    </select>
                                    <input type="tel" name="phone" placeholder="Phone number" aria-label="Phone number" required>
                                    <button class="portalSubscriptionsGridItemAddressEditFormSave portalButton primary">Update Address</button>
                                    <button class="portalSubscriptionsGridItemAddressEditFormCancel" type="button">No thanks, leave as-is</button>
                                    <button class="portalSubscriptionsGridItemAddressEditFormExit" type="button">
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Group 876">
                                                <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="portalSubscriptionsGridItemPayment">
                            <div class="portalSubscriptionsGridItemPaymentCurrent active">
                                <div class="portalSubscriptionsGridItemPaymentCurrentLabel">
                                    Payment method:
                                    <div class="portalSubscriptionsGridItemPaymentCurrentLabelUpdated">
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                        </svg>
                                        Payment Updated
                                    </div>
                                </div>
                                <div class="portalSubscriptionsGridItemPaymentCurrentName">
                                    <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group 873">
                                            <rect id="Rectangle 1905" width="28" height="17" rx="2" fill="#D9D9D9" fill-opacity="0.47"/>
                                            <rect id="Rectangle 1906" y="4" width="28" height="3" fill="#D9D9D9"/>
                                        </g>
                                    </svg>
                                    **** **** **** **** ${paymentMethod.payment_details.last4}
                                </div>
                                <button class="portalSubscriptionsGridItemPaymentCurrentModify">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                    </svg>
                                    Edit Payment
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemPaymentEdit">
                                <div class="portalSubscriptionsGridItemPaymentEditLabel">Modify payment method:</div>
                                <form class="portalSubscriptionsGridItemPaymentEditForm">
                                    <input type="number" name="cc_number" placeholder="Credit Card Number" aria-label="Credit Card Number" required>
                                    <select name="cc_exp_month" aria-label="Expiration Month" required>
                                        <option selected disabled value="">Expiration Month</option>
                                        <option value="01">Jan (01)</option>
                                        <option value="02">Feb (02)</option>
                                        <option value="03">Mar (03)</option>
                                        <option value="04">Apr (04)</option>
                                        <option value="05">May (05)</option>
                                        <option value="06">Jun (06)</option>
                                        <option value="07">Jul (07)</option>
                                        <option value="08">Aug (08)</option>
                                        <option value="09">Sep (09)</option>
                                        <option value="10">Oct (10)</option>
                                        <option value="11">Nov (11)</option>
                                        <option value="12">Dec (12)</option>
                                    </select>
                                    <select name="cc_exp_year" aria-label="Expiration Year" required>
                                        <option selected disabled value="">Expiration Year</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                        <option value="2031">2031</option>
                                        <option value="2032">2032</option>
                                        <option value="2033">2033</option>
                                        <option value="2034">2034</option>
                                        <option value="2035">2035</option>
                                        <option value="2036">2036</option>
                                        <option value="2037">2037</option>
                                        <option value="2038">2038</option>
                                        <option value="2039">2039</option>
                                        <option value="2040">2040</option>
                                    </select>
                                    <input type="number" name="cc_cvc" placeholder="CVC" aria-label="CVC" required>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormSave portalButton primary">Update Payment Method</button>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormCancel" type="button">No thanks, leave as-is</button>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormExit" type="button">
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Group 876">
                                                <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>                            
                            </div>
                    </div>
                </div>
            `;

            // check if we have a target, if so replace the content, otherwise append
            if (target) {
                target.outerHTML = HTML;
            } else {
                document.querySelector("#portalSubscriptionsGrid").insertAdjacentHTML("beforeend", HTML);
            }

            // add event listeners, save item
            let item = document.querySelector(`.portalSubscriptionsGridItem[data-id="${subscription.id}"]`);

            /********* Functions *********/

            // function to close all open forms
            function closeAllForms() {
                // close actions
                item.querySelector(".portalSubscriptionsGridItemModifyActionsCancel").click();

                // close address
                item.querySelector(".portalSubscriptionsGridItemAddressEditFormCancel").click();

                // close payment
                item.querySelector(".portalSubscriptionsGridItemPaymentEditFormCancel").click();
            }

            /******* Update Badge ********/

            // check if something was updated
            if (updated.includes("product")) {
                item.querySelector(".portalSubscriptionsGridItemHeaderUpdated").classList.add("active");
            }
            if (updated.includes("date")) {
                item.querySelector(".portalSubscriptionsGridItemDeliveryTitleUpdated").classList.add("active");
            }
            if (updated.includes("address")) {
                item.querySelector(".portalSubscriptionsGridItemAddressCurrentLabelUpdated").classList.add("active");
            }
            if (updated.includes("payment")) {
                item.querySelector(".portalSubscriptionsGridItemPaymentCurrentLabelUpdated").classList.add("active");
            }

            /***** Header ******/

            // open modify subscription
            item.querySelector(".portalSubscriptionsGridItemHeaderGeneralModify").addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemModify").classList.add("active");
            });

            /****** Modify ******/

            // update subscription (rolls/frequency)
            item.querySelector(".portalSubscriptionsGridItemModifyActionsSave").addEventListener("click", async function () {
                // list of updated items
                let updated = [];

                // get currently selected variant and cadence
                let variant = item.querySelector(".portalSubscriptionsGridItemModifyFormVariant").value;
                let variantInt = parseInt(variant);
                let cadence = item.querySelector(".portalSubscriptionsGridItemModifyFormCadence").value;

                // update object
                let updatePayload = {};

                // check if variant is different
                if (variantInt !== product.variant_id) {
                    // GA4 change variant
                    gtag('event', 'portal_change_variant');

                    updatePayload.use_external_variant_defaults = true;
                    updatePayload.external_variant_id = {
                        ecommerce: variant
                    };
                    updated.push("product");

                    // notify support
                    if (isLegacy) {
                        localStorage.setItem("isLegacy", "true");
                        await fetch(`https://api.maltertech.com/plantpaper/portal/legacy-change.php?subscriptionID=${subscription.id}`);
                    }

                }

                // check if frequency is different
                if (parseInt(cadence) !== subscription.order_interval_frequency) {
                    // GA4 change cadence
                    gtag('event', 'portal_change_cadence');

                    updatePayload.order_interval_frequency = cadence;
                    updatePayload.charge_interval_frequency = cadence;
                    updatePayload.order_interval_unit = "week";
                    updated.push("date");
                }

                // no change
                if (Object.keys(updatePayload).length === 0) {
                    await Swal.fire({
                        "icon": "error",
                        "title": "No change detected to your subscription."
                    });
                    return;
                }

                // start loading
                this.classList.add("loading");

                // update
                subscription = await recharge.subscription.updateSubscription(
                    session,
                    subscription.id,
                    updatePayload
                );

                // for canadian subscriptions, on product change, we need to reset their price since recharge doesn't use Shopfiy Market's price
                if (
                    updated.includes("product") &&
                    (
                        rollsVariantsCA.includes(variantInt) ||
                        bundlesVariantsCA.includes(variantInt) ||
                        tissueVariantCA === variantInt
                    )
                ) {
                    // refresh canadian pricing
                    await refreshCADPricing(subscription.id, address.id);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, updated);
            });

            // cancel modify subscription
            item.querySelectorAll(".portalSubscriptionsGridItemModifyActionsCancel,.portalSubscriptionsGridItemModifyExit").forEach(element => element.addEventListener("click", function () {
                // close modify container
                item.querySelector(".portalSubscriptionsGridItemModify").classList.remove("active");

                // reset variant and cadence
                item.querySelector(".portalSubscriptionsGridItemModifyFormVariant").value = product.variant_id;
                item.querySelector(".portalSubscriptionsGridItemModifyFormCadence").value = subscription.order_interval_frequency;
            }));

            /****** Resume ******/

            // resume subscription
            item.querySelector(".portalSubscriptionsGridItemResumeNow").addEventListener("click", async function () {
                // GA4 resume subscription
                gtag('event', 'portal_resume_subscription');

                // start loading
                this.classList.add("loading");

                subscription = await recharge.subscription.activateSubscription(session, subscription.id);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, []);

                // success
                await Swal.fire({
                    icon: "success",
                    title: "Your subscription has been reactivated."
                })
            });

            /****** Delivery ******/

            // choose a custom date - picker
            flatpickr(item.querySelector(".portalSubscriptionsGridItemDeliveryModify"), {
                altFormat: "D, F j, Y",
                dateFormat: "Y-m-d",
                defaultDate: subscription.next_charge_scheduled_at,
                disableMobile: true,
                minDate: new Date().fp_incr(1)
            });

            // open date picker
            item.querySelectorAll(".portalSubscriptionsGridItemHeaderGeneralCurrentModify,.portalSubscriptionsGridItemDeliveryDate").forEach(element => element.addEventListener("click", function () {
                document.querySelector(".portalSubscriptionsGridItemDeliveryModify").click();
            }));

            // choose a custom date event
            item.querySelector(".portalSubscriptionsGridItemDeliveryModify").addEventListener("change", async function () {
                // GA4 change_shipment_date
                gtag('event', 'portal_change_shipment_date');

                // start loading
                this.classList.add("loading");

                // update subscription
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, item.querySelector(".portalSubscriptionsGridItemDeliveryModify").value);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            // ship now
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleNow").addEventListener("click", async function () {
                // GA4 ship now
                gtag('event', 'portal_ship_now');

                // start loading
                this.classList.add("loading");

                // update to today
                let newChargeDate = pushDate(new Date(), 1);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a week
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleWeek").addEventListener("click", async function () {
                // GA4 push week
                gtag('event', 'portal_push_week');

                // start loading
                this.classList.add("loading");

                // update to 1 week
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 7);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a month
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleMonth").addEventListener("click", async function () {
                // GA4 push month
                gtag('event', 'portal_push_month');

                // start loading
                this.classList.add("loading");

                // push 30 days
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 30);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            /****** Address ******/

            // open address form
            item.querySelector(".portalSubscriptionsGridItemAddressCurrentModify").addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemAddressCurrent").classList.remove("active");
                item.querySelector(".portalSubscriptionsGridItemAddressEdit").classList.add("active");

                // prefill current
                item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").dispatchEvent(new Event("change"));
            });

            // change address
            item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").addEventListener("change", function () {
                // if it's a new address, we empty the form, otherwise we fill it
                if (this.value === "new") {
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm").reset();
                } else {
                    // get address
                    let address = addresses.find(address => address.id === parseInt(this.value));

                    // fill form
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='first_name']").value = address.first_name;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='last_name']").value = address.last_name;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='address1']").value = address.address1;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='address2']").value = address.address2 ?? "";
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='city']").value = address.city;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='province']").value = address.province;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='zip']").value = address.zip;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='country_code']").value = address.country_code;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='phone']").value = address.phone;
                }
            });

            // update address submit
            item.querySelector(".portalSubscriptionsGridItemAddressEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // GA4 update address
                gtag('event', 'portal_change_address');

                let form = Object.fromEntries(new FormData(this));
                if (form.address1.toLowerCase().includes('po box') || form.address1.includes('PO')) {
                    await Swal.fire({
                        icon: "error",
                        text: "We don't ship to PO Boxes at this time."
                    })
                }

                // start loading
                this.querySelector(".portalSubscriptionsGridItemAddressEditFormSave").classList.add("loading");

                // address from data
                let addressForm = Object.fromEntries(new FormData(this));

                // check if we're adding a new address
                if (item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").value === "new") {
                    // assign payment method to new address
                    addressForm.payment_method_id = paymentMethod.id;

                    // create new address
                    let updatedAddress = await recharge.address.createAddress(session, addressForm);

                    // attach address to subscription
                    subscription = await recharge.subscription.updateSubscriptionAddress(session, subscription.id, updatedAddress.id);
                } else {
                    await recharge.address.updateAddress(session, address.id, addressForm);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, ["address"]);
            });

            // cancel update (close form)
            item.querySelectorAll(".portalSubscriptionsGridItemAddressEditFormCancel,.portalSubscriptionsGridItemAddressEditFormExit").forEach(element => element.addEventListener("click", function () {
                item.querySelector(".portalSubscriptionsGridItemAddressCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemAddressEdit").classList.remove("active");
            }));

            /****** Payment ******/

            // toggle open/close modify payment
            item.querySelector(".portalSubscriptionsGridItemPaymentCurrentModify").addEventListener("click", async function () {
                // check what processor type
                if (paymentMethod.processor_name === "stripe") {
                    // close all forms
                    closeAllForms();

                    // open stripe payment form
                    item.querySelector(".portalSubscriptionsGridItemPaymentCurrent").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemPaymentEdit").classList.add("active");
                } else if (paymentMethod.processor_name === "shopify_payments") {
                    // show loading
                    Swal.fire({
                        title: 'Please Wait',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // send request
                    let formData = new FormData();
                    formData.set("paymentMethodID", paymentMethod.processor_payment_method_token);
                    let response = await fetch("https://api.maltertech.com/plantpaper/update-payment-shopify.php", {
                        method: "POST",
                        body: formData
                    })
                        .then(data => data.json());

                    // check for error
                    if (response.error) {
                        await Swal.fire({
                            icon: "error",
                            title: response.error
                        });
                        return;
                    }

                    await Swal.fire({
                        title: "For security reasons, please check your email to update your payment method."
                    });
                } else {
                    await Swal.fire({
                        "icon": "error",
                        "title": "Please contact support with error P2."
                    });
                }
            });

            // update payment
            item.querySelector(".portalSubscriptionsGridItemPaymentEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // start loading
                this.querySelector(".portalSubscriptionsGridItemPaymentEditFormSave").classList.add("loading");

                // send request
                let formData = new FormData(this);
                formData.set("recharge_customer_id", session.customerId)
                formData.set("stripe_customer_id", paymentMethod.processor_customer_token);
                formData.set("recharge_address_id", address.id);
                let response = await fetch("https://api.maltertech.com/plantpaper/update-payment-stripe.php", {
                    method: "POST",
                    body: formData
                })
                    .then(data => data.json());

                // stop loading
                this.querySelector(".portalSubscriptionsGridItemPaymentEditFormSave").classList.remove("loading");

                // check for error
                if (response.error) {
                    await Swal.fire({
                        icon: "error",
                        title: response.error
                    });
                    return;
                }

                // render subscription
                await renderSubscription(item, true, ["payment"]);
            });

            // cancel update
            item.querySelectorAll(".portalSubscriptionsGridItemPaymentEditFormCancel,.portalSubscriptionsGridItemPaymentEditFormExit").forEach(element => element.addEventListener("click", function () {
                // close the form
                item.querySelector(".portalSubscriptionsGridItemPaymentCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemPaymentEdit").classList.remove("active");

                // reset form
                item.querySelector(".portalSubscriptionsGridItemPaymentEditForm").reset();
            }));
        }

        // initial render
        renderSubscription(null, false, []);
    });

    /************** Tissue Upsell *****************/

    // function to setup tissues if eligible
    function setupEligibleTissueOffers() {
        // bring us back to the initial state as data may have changed
        document.querySelector('#portalSubscriptionsTissuesOptions').classList.remove("active");
        document.querySelectorAll(".portalSubscriptionsTissuesOptionsLabelInput").forEach(element => element.checked = false);
        document.querySelector('#portalSubscriptionsTissuesAddress').classList.remove("active");
        document.querySelector("#portalSubscriptionsTissuesButton").textContent = "Order Facial Tissue";

        // determine if the person is eligible for tissues
        let eligible = false;

        // Must have an active subscription that is any rolls variant
        subscriptions.forEach(subscription => {
            let variantID = parseInt(subscription.external_variant_id.ecommerce);
            if (subscription.status === "active" && (rollsVariantsUS.includes(variantID) || rollsVariantsCA.includes(variantID))) {
                eligible = true;
            }
        });

        // Must not have any ACTIVE subscription that are bundles or tissues
        subscriptions.forEach(subscription => {
            let variantID = parseInt(subscription.external_variant_id.ecommerce);
            if (
                subscription.status === "active" &&
                (
                    bundlesVariantsUS.includes(variantID) ||
                    bundlesVariantsCA.includes(variantID) ||
                    variantID === tissueVariantUS ||
                    variantID === tissueVariantCA
                )
            ) {
                eligible = false;
            }
        });

        // show upsell if eligible
        if (eligible) {
            document.querySelector("#portalSubscriptionsTissues").classList.add("active");
        } else {
            document.querySelector("#portalSubscriptionsTissues").classList.remove("active");
            return;
        }

        // hide both 16 and 32 pack title and options
        document.querySelector(".portalSubscriptionsTissuesOptionsTitle[data-eligible='16,32']").classList.remove("active");
        document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="16"]`).classList.remove("active");
        document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="32"]`).classList.remove("active");

        // determine how many active 16 and 32 pack subscriptions they have
        let active16Packs = [];
        let active32Packs = [];
        if (window.location.hostname === "plantpaper.us") {
            active16Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[0]);
            active32Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[1]);
        } else {
            active16Packs = [];
            active32Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[0]);
        }

        // if they have any active subscriptions
        if (active16Packs.length > 0 || active32Packs.length > 0) {
            // show title
            document.querySelector(".portalSubscriptionsTissuesOptionsTitle[data-eligible='16,32']").classList.add("active");

            // show 16 + 4 if they have 16 packs
            if (active16Packs.length > 0) {
                document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="16"]`).classList.add("active");
            }

            // show 32 + 8 if they have 32 packs
            if (active32Packs.length > 0) {
                document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="32"]`).classList.add("active");
            }
        }

    }

    // initial setup
    setupEligibleTissueOffers();

    // start button click
    document.querySelector("#portalSubscriptionsTissuesButton").addEventListener("click", async function () {
        // PHASE 1 - start
        if (this.textContent === "Order Facial Tissue") {
            // update atc text
            this.textContent = `Add tissues to my subscription`;

            // show options container
            document.querySelector("#portalSubscriptionsTissuesOptions").classList.add("active");
        }

        // PHASE 2 - get address
        else if (this.textContent === "Add tissues to my subscription") {
            // check if no an option is selected
            if (document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked") === null) {
                await Swal.fire({
                    text: "Please select a tissue offer to continue."
                });
                return;
            }

            // hide options container
            document.querySelector("#portalSubscriptionsTissuesOptions").classList.remove("active");

            // show address container
            document.querySelector("#portalSubscriptionsTissuesAddress").classList.add("active");

            // get active option
            let upsell = document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked").value;

            // eligible subscriptions represents the subscriptions that are eligible for the upsell
            let eligibleSubscriptions;

            if (window.location.hostname === "plantpaper.us") {
                // get list of eligible 16 packs
                if (upsell === "16+4") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[0]);
                }
                // get list of eligible 32 packs
                else if (upsell === "32+8") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[1]);
                }
                // tissues we show all active subscriptions
                else {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active");
                }
            } else {
                // get list of eligible 32 packs
                if (upsell === "32+8") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[0]);
                }
                // tissues we show all active subscriptions
                else {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active");
                }
            }

            // generate a list of addresses without duplicates
            let eligibleAddresses = [];
            eligibleSubscriptions.forEach(subscription => {
                if (!eligibleAddresses.includes(subscription.address_id)) {
                    eligibleAddresses.push(subscription.address_id);
                }
            });

            // add address for next step that are eligible
            let HTML = "";
            addresses.forEach(address => {
                if (eligibleAddresses.includes(address.id)) {
                    HTML += `<option value="${address.id}">${address.address1}</option>`;
                }
            });

            // create options
            document.querySelector("#portalSubscriptionsTissuesAddressSelect").innerHTML = HTML;

            // update atc text
            this.textContent = `Confirm address`;

            // AUTO CONFIRM ADDRESS IF ONLY ONE
            if (eligibleAddresses.length === 1) {
                this.click();
            }
        }

        // PHASE 3 - confirm payment
        else if (this.textContent === "Confirm address") {
            // hide address container
            document.querySelector("#portalSubscriptionsTissuesAddress").classList.remove("active");

            // start loading
            this.classList.add("loading");

            // get active option
            let upsell = document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked").value;

            // get the selected address
            let address = addresses.find(address => address.id === parseInt(document.querySelector("#portalSubscriptionsTissuesAddressSelect").value));

            // find the first subscription with this address that's active
            let subscription = subscriptions.find(subscription => subscription.status === "active" && subscription.address_id === address.id);

            // if they're upgrading to the 16+4 or 32+8, we need to update they're existing subscription
            if (upsell === "16+4" || upsell === "32+8") {
                if (window.location.hostname === "plantpaper.us") {
                    await recharge.subscription.updateSubscription(session, subscription.id, {
                        external_variant_id: {
                            ecommerce: (upsell === "16+4") ? `${bundlesVariantsUS[0]}` : `${bundlesVariantsUS[1]}`
                        }
                    });
                } else {
                    let updatedSubscription = await recharge.subscription.updateSubscription(session, subscription.id, {
                        external_variant_id: {
                            ecommerce: `${bundlesVariantsCA[0]}`
                        }
                    });

                    // refresh canadian pricing
                    await refreshCADPricing(updatedSubscription.id, updatedSubscription.address_id);
                }

                // notify support
                if (isLegacy) {
                    localStorage.setItem("isLegacy", "true");
                    await fetch(`https://api.maltertech.com/plantpaper/portal/legacy-change.php?subscriptionID=${subscription.id}`);
                }
            }
            // otherwise we need to create a new subscription for the tissues
            else {
                // get interval
                let interval = parseInt(document.querySelector(".portalSubscriptionsTissuesOptionsLabelFrequency").value);

                // create new subscription
                if (window.location.hostname === "plantpaper.us") {
                    await recharge.subscription.createSubscription(session, {
                        address_id: address.id,
                        next_charge_scheduled_at: subscriptions.find(subscription => subscription.status === "active").next_charge_scheduled_at,
                        charge_interval_frequency: interval,
                        order_interval_frequency: interval,
                        order_interval_unit: 'week',
                        quantity: 1,
                        external_variant_id: {
                            ecommerce: `${tissueVariantUS}`,
                        },
                        external_product_id: {
                            ecommerce: `${products[tissueVariantUS].id}`,
                        }
                    });
                } else {
                    let newSubscription = await recharge.subscription.createSubscription(session, {
                        address_id: address.id,
                        next_charge_scheduled_at: subscriptions.find(subscription => subscription.status === "active").next_charge_scheduled_at,
                        charge_interval_frequency: interval,
                        order_interval_frequency: interval,
                        order_interval_unit: 'week',
                        quantity: 1,
                        external_variant_id: {
                            ecommerce: `${tissueVariantCA}`,
                        },
                        external_product_id: {
                            ecommerce: `${products[tissueVariantCA].id}`,
                        }
                    });

                    // refresh canadian pricing
                    await refreshCADPricing(newSubscription.id, newSubscription.address_id);

                }
            }

            // stop loading
            this.classList.remove("loading");

            // success
            await Swal.fire({
                icon: "success",
                title: "Tissues have been added successfully.",
            });

            // refresh
            Swal.fire({
                title: 'Refreshing',
                allowOutsideClick: () => !Swal.isLoading()
            });
            Swal.showLoading();
            window.location.reload();
        }

    });


    /********* General Account Functions **********/

    // recharge sms
    document.querySelector("#portalAccountSMS")?.addEventListener("click", async function () {
        await Swal.fire({
            title: "SMS Management",
            html: `
                <iframe id="sms" src="https://plantpaper-sp.admin.rechargeapps.com/sms/opt-in/328/?heroCopyFontColor=000&heroCopy=Activating+this+service+requires+a+double+verification.+Two+unique+security+codes+will+be+sent+to+your+phone+%28via+text%29+and+your+email%2C+respectively.+Please+enter+both+codes+upon+receipt.%0A%0A*Note+that+there+may+be+a+1-2+minute+delay+in+receiving+the+email.&ctaButtonLabel=Let%27s+do+it&ctaButtonColor=ff9417&ctaButtonFontColor=ffffff&email=${customer.email}" frameBorder="0" height="330"></iframe>
           `,
            showConfirmButton: false
        });
    });


    // see past orders
    document.querySelector("#portalAccountPastOrders").addEventListener("click", async function () {
        // GA4 view past orders
        gtag('event', 'portal_view_past_orders');

        // return date and time
        function getDateTime(date) {
            let dateObj = new Date(parseInt(date["$date"]["$numberLong"]));
            return `${dateObj.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                }
            )}`;
        }

        // send request
        let formData = new FormData();
        formData.set("email", customer.email);
        formData.set("customerID", customer.external_customer_id.ecommerce);
        let response = await fetch("https://api.maltertech.com/plantpaper/portal/get-orders.php", {
            method: "POST",
            body: formData
        })
            .then(response => response.json());

        // check for error
        if (response.error) {
            await Swal.fire({
                icon: "error",
                title: response.error
            });
            return;
        }

        // generate HTML
        let HTML = `
            <table>
                <tr>
                    <td><b>Order #</b></td>
                    <td><b>Order Date</b></td>
                    <td><b>Total Price</b></td>
                </tr>
        `;
        response.forEach(order => {
            HTML += `
                <tr>
                    <td><a href="${order.order_status_url}" target="_blank">#${order.name}</a></td>
                    <td>${getDateTime(order.created_at)}</td>
                    <td>$${order.total_price}</td>
                </tr>
            `;
        })
        HTML += "</table>"

        // show popup
        await Swal.fire({
            "title": "Past Orders",
            "html": HTML,
            "customClass": {
                popup: "malterWide"
            }
        })

    });

    // show inactive subscriptions
    document.querySelector("#portalAccountInactiveSubscriptions").addEventListener("click", async function () {
        // check if we have any cancelled subscriptions
        if (subscriptions.filter(subscription => subscription.status === "cancelled").length === 0) {
            await Swal.fire({
                title: "You do not have any inactive subscriptions to cancel."
            });
            return;
        }

        // show label
        document.querySelector("#portalSubscriptionsGridCancelled").classList.toggle("active");

        // show all hidden subscriptions
        document.querySelectorAll(`.portalSubscriptionsGridItem[data-status="cancelled"]`).forEach(item => item.classList.toggle("active"));

        // smooth scroll
        document.querySelector("#portalSubscriptionsGridCancelled").scrollIntoView();

        // update label
        if (document.querySelector("#portalSubscriptionsGridCancelled").classList.contains("active")) {
            this.textContent = "Hide inactive subscriptions";
        } else {
            this.textContent = "Show inactive subscriptions";
        }
    });

    // logout
    document.querySelector("#portalAccountLogout").addEventListener("click", logout);

    /********* Cancel Subscription **********/

    // cancel subscription open
    dialogPolyfill.registerDialog(document.querySelector("#cancel"));
    document.querySelector("#portalAccountCancel").addEventListener("click", async function () {
        // GA4 cancel subscription
        gtag('event', 'portal_cancel_subscription');

        // check if we have any active subscriptions
        if (subscriptions.filter(subscription => subscription.status === "active").length === 0) {
            await Swal.fire({
                title: "You do not have any active subscriptions to cancel."
            });
            return;
        }

        // reset container
        document.querySelector("#cancelSubscriptions").innerHTML = "";

        // append new subscriptions
        subscriptions.forEach(subscription => {
            // only show active subscriptions
            if (subscription.status !== "active") {
                return;
            }

            // find address
            let address = addresses.find(address => address.id === subscription.address_id);

            // append
            document.querySelector("#cancelSubscriptions").insertAdjacentHTML("beforeend", `
                <label class="cancelSubscriptionsItem" data-id="${subscription.id}">
                    <input class="cancelSubscriptionsItemCheckbox" name="cancel_subscription" type="radio" value="${subscription.id}">
                    <div class="cancelSubscriptionsItemProduct">${subscription.product_title}</div>
                    <div class="portalSubscriptionsItemAddress">
                        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"></path> </svg>
                        ${address.address1}
                    </div>
                </label>
            `)
        });

        // open popup
        document.querySelector("#cancel").showModal();
    });

    // cancel subscription
    document.querySelector("#cancelConfirm").addEventListener("click", async function () {
        // get selected element
        let selected = document.querySelector(".cancelSubscriptionsItemCheckbox:checked");

        // check if one is selected
        if (!selected) {
            await Swal.fire({
                title: "Please select a subscription to cancel.",
                target: "#cancel"
            });
            return;
        }

        // start loading
        document.querySelector("#cancelConfirm").classList.add("loading");

        // cancel
        await recharge.subscription.cancelSubscription(session, parseInt(selected.value), {
            cancellation_reason: 'Do not want it anymore.',
            send_email: true,
        });

        // close modal
        document.querySelector("#cancel").close();

        // success
        await Swal.fire({
            icon: "success",
            title: "Your subscription has been cancelled successfully.",
        });

        // refresh
        Swal.fire({
            title: 'Refreshing',
            allowOutsideClick: () => !Swal.isLoading()
        });
        Swal.showLoading();
        window.location.reload();
    });

    // cancel subscription backdrop
    document.querySelector("#cancel").addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });

    // cancel subscription - button
    document.querySelectorAll("#cancelCancel,#cancelExit").forEach(element => element.addEventListener("click", function () {
        document.querySelector("#cancel").close();
    }));

    /**************** Start Portal **********/

    // show portal
    document.querySelector("#loading").classList.remove("active");
    document.querySelector("#intro").classList.add("active");
    document.querySelector("#portal").classList.add("active");
}

setupPortal();